import { useContext } from "react"
import { Card, FooterMenu, HeaderMenu } from "components"
import { ChildItem } from "./components"
import { PdfLinkAccount } from "pages/Setup/Account/components"
import { dataAccountLink, Render, RenderProvider } from "./utils"
import { exportPdf } from "utils"
import { LinkAccountContext, LinkAccountProvider } from "pages/Setup/contexts"

export default function MobileApprove() {
  return (
    <RenderProvider>
      <LinkAccountProvider>
        <section className="container pt-5  gap-5 flex flex-col">
          <HeaderMenu title="DATA ENTRY | MOBILE APPROVE " className="sticky top-[-20px] z-[3]" />

          <Card>
            <Card.Body>
              <div className="overflow-x-auto">
                <TableContent />
              </div>
            </Card.Body>
          </Card>

          <Footer />
        </section>
      </LinkAccountProvider>
    </RenderProvider>
  )
}

function TableContent() {
  const { render } = useContext(Render)

  if (render) {
    return <ChildItem />
  } else {
    return <div />
  }
}


function Footer(): JSX.Element {

  const { data } = useContext(LinkAccountContext)

  return (
    <FooterMenu
      pdf={{
        actiontype: "pdf",
        onClick: () => {
          exportPdf({
            documentComponent:<PdfLinkAccount
              dataLinkAccount={dataAccountLink}
              dataList={data}
              title="General Link Account "
            />,
            fileName: "Link Account"
          })
        }
      }}
    />
  )
}